import script from "./ProcessosMovimentacaoForm_24.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessosMovimentacaoForm_24.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__